import { tv } from 'tailwind-variants'
import { cn } from '@scalis/utils'
import { TimelineColor, TimelineOverlayColor } from './timeline.types'

export const ulClassName = tv({
  base: cn('flex relative flex-col gap-2 pl-5 ml-1'),
})

export const timelineLineClassName = tv({
  base: 'absolute w-[2px] left-0 h-[100%] z-0',
  variants: {
    color: {
      [TimelineColor.BLUE]: 'bg-brand-primary-rest',
      [TimelineColor.GRAY]: 'bg-neutral-30',
      [TimelineColor.GREEN]: 'bg-icon-status-success-20',
      [TimelineColor.RED]: 'bg-icon-status-critical-rest',
    },
  },
})

export const liClassName = tv({
  base: cn('flex flex-col relative'),
  variants: {
    overlay: {
      true: 'after:content-[""] after:absolute after:left-[-1.3em] after:w-[3px] after:h-[calc(15px-6px)] after:top-0 after:border-none last:after:top-auto last:after:bottom-0 last:after:h-[calc(100%-9px)] z-1',
    },
    overlayColor: {
      [TimelineOverlayColor.BRAND_PRIMARY_LIGHT_00]: 'after:bg-brand-primary-light-00',
      [TimelineOverlayColor.WHITE]: 'after:bg-white',
    },
  },
})

export const customDotClassName = tv({
  base: 'absolute left-[-1.6em] w-3 h-3 top-[15px] -translate-x-1/2 -translate-y-1/2 z-1',
})

export const defaultDotClassName = tv({
  base: 'absolute bg-white left-[-1.2em] w-3 h-3 rounded-full top-[15px] -translate-x-1/2 -translate-y-1/2 border-4 border-brand-primary-rest z-1',
  variants: {
    color: {
      [TimelineColor.BLUE]: 'border-brand-primary-rest',
      [TimelineColor.GRAY]: 'border-neutral-30',
      [TimelineColor.GREEN]: 'border-icon-status-success-20',
      [TimelineColor.RED]: 'border-icon-status-critical-rest',
    },
  },
})
